import { render, staticRenderFns } from "./default.vue?vue&type=template&id=39336072&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=39336072&scoped=true&lang=css"
import style1 from "./default.vue?vue&type=style&index=1&id=39336072&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39336072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39336072')) {
      api.createRecord('39336072', component.options)
    } else {
      api.reload('39336072', component.options)
    }
    module.hot.accept("./default.vue?vue&type=template&id=39336072&scoped=true", function () {
      api.rerender('39336072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/default.vue"
export default component.exports